export const getApiBaseUrl = (
  location = typeof window === 'undefined' ? null : window.location
) => {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  if (!location) return 'http://localhost:8000';
  if (location.protocol === 'https:') return location.origin;
  if (location.hostname !== 'localhost' && location.hostname !== '127.0.0.1') {
    return `http://${location.hostname}:8000`;
  }
  return 'http://localhost:8000';
};

const getApiUrl = () => `${getApiBaseUrl()}/api`;

export const API_CONFIG = {
  BASE_URL: getApiBaseUrl(),
  API_URL: getApiUrl(),
  auth: {
    login: () => `${getApiUrl()}/auth/login/`,
    register: () => `${getApiUrl()}/auth/register/`,
    logout: () => `${getApiUrl()}/auth/logout/`,
    refresh: () => `${getApiUrl()}/auth/refresh/`,
    user: () => `${getApiUrl()}/auth/user/`,
    downloadCV: (format) => `${getApiUrl()}/auth/cv/?cv_format=${format}`,
  },
  courses: {
    list: () => `${getApiUrl()}/courses/`,
    detail: (id) => `${getApiUrl()}/courses/${id}/`,
    randomFeatured: () => `${getApiUrl()}/courses/random-featured/`,
  },
  registrations: {
    register: (courseId) => `${getApiUrl()}/registrations/register/${courseId}/`,
    withdraw: (registrationId) => `${getApiUrl()}/registrations/withdraw/${registrationId}/`,
    myRegistrations: () => `${getApiUrl()}/registrations/my-registrations/`,
    dashboardStats: () => `${getApiUrl()}/registrations/dashboard-stats/`,
    registrationStatus: () => `${getApiUrl()}/registrations/registration-status/`,
    adminList: (status) => `${getApiUrl()}/registrations/admin/all/${status ? `?status=${status}` : ''}`,
    wishlist: () => `${getApiUrl()}/registrations/wishlist/`,
    documents: () => `${getApiUrl()}/registrations/documents/`,
    documentDetail: (id) => `${getApiUrl()}/registrations/documents/${id}/`,
    verifyDocument: (id) => `${getApiUrl()}/registrations/documents/verify/${id}/`,
    interviews: () => `${getApiUrl()}/registrations/interviews/`,
    placements: () => `${getApiUrl()}/registrations/placements/`,
  },
  career: {
    base: () => `${getApiUrl()}/career`,
    recommendations: () => `${getApiUrl()}/career/recommendations/`,
    regenerateRecommendations: () => `${getApiUrl()}/career/recommendations/regenerate/`,
    compareCourses: () => `${getApiUrl()}/career/compare-courses/`,
    comparisons: () => `${getApiUrl()}/career/comparisons/`,
  },
  lms: {
    enrollments: () => `${getApiUrl()}/registrations/lms-enrollments/`,
    acceptEnrollment: () => `${getApiUrl()}/registrations/lms-enrollments/accept/`,
    enrollmentDetail: (publicId) => `${getApiUrl()}/registrations/lms-enrollments/${publicId}/`,
    enrollmentLaunch: (publicId) => `${getApiUrl()}/registrations/lms-enrollments/${publicId}/launch/`,
    webhook: () => `${getApiUrl()}/registrations/lms/webhook/`,
  },
  announcements: {
    base: () => `${getApiUrl()}/announcements`,
    pushSubscribe: () => `${getApiUrl()}/announcements/push/subscribe/`,
    pushUnsubscribe: () => `${getApiUrl()}/announcements/push/unsubscribe/`,
  },
  admin: {
    djangoAdmin: () => `${getApiBaseUrl()}/admin/`,
  },
};

export default API_CONFIG;
